<template>
  <div class="settingLearning edit-style detail">
    <!-- {{ routeData }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="goBack" />
      <p class="title">设置参数</p>
      <div class="hidden-box"></div>
    </div>
    <van-field
      readonly
      clickable
      label="学科选择"
      :value="subjectVal"
      placeholder="选择学科"
      @click="subjectType = true"
    />
    <van-popup v-model="subjectType" round position="bottom">
      <van-picker
        show-toolbar
        :columns="subjectList"
        @cancel="subjectType = false"
        @confirm="subjectSuc"
      />
    </van-popup>
    <van-field
      readonly
      clickable
      label="时间段"
      :value="timeVal"
      placeholder="选择时间段"
      @click="timeType = true"
    />
    <van-popup v-model="timeType" round position="bottom">
      <van-picker
        show-toolbar
        :columns="timeList"
        @cancel="timeType = false"
        @confirm="timeSuc"
      />
    </van-popup>
    <template v-if="!$route.query.isStudent">
      <van-field
        readonly
        clickable
        label="年级"
        :value="gradeVal"
        placeholder="选择年级"
        @click="gradeType = true"
      />
      <van-popup v-model="gradeType" round position="bottom">
        <van-picker
          show-toolbar
          :columns="gradeList"
          @cancel="gradeType = false"
          @confirm="gradeSuc"
        />
      </van-popup>
      <van-field
        v-if="$route.query.urlType != 'grade'"
        readonly
        clickable
        label="班级"
        :value="classVal"
        placeholder="选择班级"
        @click="classType = true"
      />
      <van-popup v-model="classType" round position="bottom">
        <van-picker
          show-toolbar
          :columns="classList"
          @cancel="classType = false"
          @confirm="classSuc"
        />
      </van-popup>
      <van-field
        v-if="$route.query.urlType == 'student'"
        readonly
        clickable
        label="学生"
        :value="studentVal"
        placeholder="选择学生"
        @click="studentType = true"
      />
      <van-popup v-model="studentType" round position="bottom">
        <van-picker
          show-toolbar
          :columns="studentList"
          @cancel="studentType = false"
          @confirm="studentSuc"
        />
      </van-popup>
    </template>
    <div class="btn-box">
      <van-button type="primary" block @click="setData">确定</van-button>
      <van-button type="default" block @click="goBack">取消</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  getGradelist,
  classlistbygrade,
  querypage,
  subjectlistbygrade,
  subjectlistbygradeandclassnum,
} from "@/api/interface";
import { subjectOptions, optionsTime } from "@/util/constdata";
export default {
  name: "SettingLearning",
  data() {
    return {
      subjectOptions: subjectOptions,
      subjectList: [],
      subjectVal: "",
      optionsTime: optionsTime,
      subjectType: false,
      timeList: [],
      timeVal: "",
      timeType: false,
      gradeOption: [],
      gradeList: [],
      gradeVal: "",
      gradeType: false,
      classOption: [],
      classList: [],
      classVal: "",
      classType: false,
      studentOption: [],
      studentList: [],
      studentVal: "",
      studentType: false,
      routeData: {},
    };
  },
  created() {
    this.routeData = JSON.parse(JSON.stringify(this.$route.query));
    this.initOption();
  },
  mounted() {
    window.goBackView = this.goBackView;
  },
  methods: {
    // this.$route.query.isStudent
    goBackView() {
      this.goBack();
      // window.mobile.closeMobileUI();
    },
    isStudent(data) {
      let olddata = this.$route.query;
      Object.assign(olddata, data);
      this.$router.push({
        name: this.routeData.path,
        query: olddata,
      });
    },
    setData() {
      let data = {
        timeRange: this.optionsTime.filter((i) => i.label == this.timeVal)[0]
          .value,
      };
      if (this.$route.query.isWeb) {
        data.isWeb = true;
      }
      //如果是学生  只需要获取两个参数
      if (this.$route.query.isStudent) {
        // subjectOptions
        // console.log(this.subjectVal);

        data.subjectId = this.subjectOptions.filter(
          (i) => i.label == this.subjectVal
        )[0].value;
        let queryData = Object.assign(this.$route.query, data);
        delete queryData.path;
        delete queryData.urlType;
        this.$router.push({
          name: this.routeData.path,
          query: queryData,
        });
        return;
      } else {
        data.subjectId = this.subjectOptions.filter(
          (i) => i.name == this.subjectVal
        )[0].id;
      }
      data.gradeId = this.gradeOption.filter(
        (i) => i.name == this.gradeVal
      )[0].id;
      // if (this.$route.query.urlType != "student") {
      //   data.subjectId = this.subjectOptions.filter(
      //     (i) => i.name == this.subjectVal
      //   )[0].id;
      // }
      let classNumType = false;
      if (this.$route.query.urlType != "grade") {
        if (
          this.classOption.filter((i) => i.name == this.classVal).length == 0
        ) {
          classNumType = true;
        } else {
          data.classNum = this.classOption.filter(
            (i) => i.name == this.classVal
          )[0].classNum;
        }
      }
      if (classNumType) {
        Toast("请选择正确的班级");
        return;
      }
      let studentType = false;
      if (this.$route.query.urlType == "student") {
        if (
          this.studentOption.filter((i) => i.name == this.studentVal).length ==
          0
        ) {
          studentType = true;
        } else {
          this.studentOption.forEach((item) => {
            if (item.name == this.studentVal) {
              data.studentId = item.id;
            }
          });
          // data.studentId = this.studentOption.filter(
          //   (i) => i.name == this.studentVal
          // )[0].id;
        }
      }
      if (studentType) {
        Toast("请选择正确的学生");
        return;
      }
      let queryData = Object.assign(this.$route.query, data);
      delete queryData.path;
      delete queryData.urlType;
      // console.log(this.$route.query)
      // console.log(queryData)
      this.$router.push({
        name: this.routeData.path,
        query: queryData,
      });
    },
    initOption() {
      this.timeVal = this.optionsTime.filter(
        (i) => i.value == this.routeData.timeRange
      )[0].label;
      //初始化科目
      // 初始化时间段
      this.optionsTime.forEach((item) => {
        this.timeList.push(item.label);
      });
      if (this.$route.query.isStudent) {
        // if()
        this.subjectOptions.splice(4, 0, { value: 11, label: "道德与法治" });
        if (this.routeData.levelId == 2) {
          this.subjectOptions = this.subjectOptions.filter(
            (item) => item.value != 6
          );
        } else {
          this.subjectOptions = this.subjectOptions.filter(
            (item) => item.value != 11
          );
        }
        // console.log(this.subjectOptions);
        this.subjectOptions.forEach((item) => {
          this.subjectList.push(item.label);
        });
        this.subjectVal = this.subjectOptions.filter(
          (i) => i.value == this.routeData.subjectId
        )[0].label;
        return;
      }

      // this.subjectOptions.forEach((item) => {
      //   this.subjectList.push(item.label);
      // });
      // 如果是年级，获取科目列表
      if (this.$route.query.urlType == "grade") {
        this.subjectlistbygrade(this.routeData.gradeId);
      }

      if (this.$route.query.urlType == "class") {
        this.subjectlistbygradeandclassnum(
          this.routeData.gradeId,
          this.routeData.classNum
        );
      }
      if (this.$route.query.urlType == "student") {
        this.studentSubject();
      }

      // 初始化年级
      let data = {
        token: this.routeData.token,
        schoolID: this.routeData.schoolID,
      };
      getGradelist(data).then((res) => {
        this.gradeOption = res.data;
        res.data.forEach((item) => {
          this.gradeList.push(item.name);
        });
        this.gradeVal = this.gradeOption.filter(
          (i) => i.id == this.routeData.gradeId
        )[0].name;
      });
      // 初始化班级
      if (this.routeData.classNum) {
        data.gradeId = this.routeData.gradeId;
        this.getClass(data);
      }
      // 初始化学生
      if (this.routeData.studentId) {
        data.classNum = this.routeData.classNum;
        data.current = 1;
        data.size = 100;
        // size: 100
        this.getStudent(data);
      }
    },
    //学生初始化科目
    studentSubject() {
      this.subjectOptions.splice(4, 0, { value: 11, label: "道德与法治" });
      if (this.routeData.levelId == 2) {
        this.subjectOptions = this.subjectOptions.filter(
          (item) => item.value != 6
        );
      } else {
        this.subjectOptions = this.subjectOptions.filter(
          (item) => item.value != 11
        );
      }
      this.subjectVal = this.subjectOptions.filter(
        (i) => i.value == this.routeData.subjectId
      )[0].label;
      let arr = [];
      this.subjectList = [];
      this.subjectOptions.forEach((item) => {
        arr.push({
          id: item.value,
          name: item.label,
        });
        this.subjectList.push(item.label);
      });
      this.subjectOptions = arr;
    },
    // 年级获取科目id
    subjectlistbygrade(gradeId) {
      let data = {
        token: this.routeData.token,
        gradeId: gradeId,
      };
      this.subjectVal = "";
      this.subjectOptions = [];
      subjectlistbygrade(data).then((res) => {
        this.subjectOptions = res.data;
        this.subjectOptions.forEach((item) => {
          this.subjectList.push(item.name);
        });
        this.subjectVal = this.subjectOptions.filter(
          (i) => i.id == this.routeData.subjectId
        )[0].name;
      });
    },
    // 班级获取科目id
    subjectlistbygradeandclassnum(gradeId, classNum) {
      let data = {
        token: this.routeData.token,
        gradeId: gradeId,
        classNum: classNum,
      };
      this.subjectVal = "";
      this.subjectOptions = [];
      subjectlistbygradeandclassnum(data).then((res) => {
        this.subjectOptions = res.data;
        this.subjectOptions.forEach((item) => {
          this.subjectList.push(item.name);
        });
        this.subjectVal = this.subjectOptions.filter(
          (i) => i.id == this.routeData.subjectId
        )[0].name;
      });
    },
    goBack() {
      let data = JSON.parse(JSON.stringify(this.routeData));
      delete data.path;
      this.$router.push({
        name: this.routeData.path,
        query: data,
      });
    },
    getStudent(data) {
      querypage(data).then((res) => {
        this.studentOption = res.data.records;
        res.data.records.forEach((item) => {
          this.studentList.push(item.name);
        });
        if (this.routeData.studentId) {
          this.studentVal = this.studentOption.filter(
            (i) => i.id == this.routeData.studentId
          )[0].name;
        }
      });
    },
    getClass(data) {
      classlistbygrade(data).then((res) => {
        this.classOption = res.data;
        // console.log(this.classOption);
        res.data.forEach((item) => {
          this.classList.push(item.name);
        });
        if (this.routeData.classNum) {
          this.classVal = this.classOption.filter(
            (i) => i.classNum == this.routeData.classNum
          )[0].name;
        } else {
          this.classVal = this.classOption[0].classNum;
          let gradeId = this.gradeOption.filter(
            (i) => i.name == this.gradeVal
          )[0].id;
          let classNum = this.classOption.filter(
            (i) => i.name == this.classVal
          )[0].classNum;
          //
          if (this.$route.query.urlType != "student") {
            this.subjectlistbygradeandclassnum(gradeId, classNum);
          }
        }
      });
    },
    setClass() {
      let data = {
        token: this.routeData.token,
        schoolID: this.routeData.schoolID,
        gradeId: this.gradeOption.filter((i) => i.name == this.gradeVal)[0].id,
      };
      this.getClass(data);
    },
    setStudent() {
      let data = {
        token: this.routeData.token,
        schoolID: this.routeData.schoolID,
        gradeId: this.gradeOption.filter((i) => i.name == this.gradeVal)[0].id,
        classNum: this.classOption.filter((i) => i.name == this.classVal)[0]
          .classNum,
        current: 1,
        size: 100,
      };
      this.getStudent(data);
    },
    subjectSuc(value) {
      this.subjectVal = value;
      this.subjectType = false;
    },
    timeSuc(value) {
      this.timeVal = value;
      this.timeType = false;
    },
    gradeSuc(value) {
      this.gradeVal = value;
      this.gradeType = false;
      if (this.$route.query.urlType != "grade") {
        this.routeData.classNum = "";
        this.classVal = "";
        this.classOption = [];
        this.classList = [];
        this.setClass();
      }
      if (this.$route.query.urlType == "grade") {
        let gradeId = this.gradeOption.filter((i) => i.name == this.gradeVal)[0]
          .id;
        this.subjectlistbygrade(gradeId);
      }
      if (this.$route.query.urlType == "student") {
        this.routeData.studentId = "";
        this.studentVal = "";
        this.studentOption = [];
        this.studentList = [];
      }
    },
    classSuc(value) {
      this.classVal = value;
      this.classType = false;

      if (this.$route.query.urlType == "class") {
        this.subjectVal = "";
        this.subjectOptions = [];
        let gradeId = this.gradeOption.filter((i) => i.name == this.gradeVal)[0]
          .id;
        let classNum = this.classOption.filter(
          (i) => i.name == this.classVal
        )[0].classNum;
        //
        if (this.$route.query.urlType != "student") {
          this.subjectlistbygradeandclassnum(gradeId, classNum);
        }
      }
      if (this.$route.query.urlType == "student") {
        this.routeData.studentId = "";
        this.studentVal = "";
        this.studentOption = [];
        this.studentList = [];
        this.setStudent();
      }
    },
    studentSuc(value) {
      this.studentVal = value;
      this.studentType = false;
    },
  },
};
</script>
<style scoped lang="scss">
.settingLearning {
  .hidden-box {
    width: 24px;
  }
  .van-cell {
    padding: 10px 22px;
  }
  .btn-box {
    // margin-top: 20px;
    padding: 0 12px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    .van-button {
      border-radius: 4px;
      margin-bottom: 8px;
    }
    .van-button--primary {
      background-color: #7b9cc7;
      border-color: #7b9cc7;
    }
    // 10c694
    .van-button--default {
      background-color: rgba(0, 0, 0, 0.85);
      color: white;
    }
  }
}
</style>
